import { Component, OnInit, OnDestroy, Inject, ChangeDetectorRef, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DnEmojiService } from '../../_service/dn-emojis/emoji.service';
import {  Unsubscribable } from 'rxjs';
import { RechargeBoxService } from '../../_service/recharge-box/recharge-box.service';
import { PermissionService, SysName } from '../../PermissionService';
import { UserService } from '../../_service/user/user.service';

@Component({
  selector: 'app-emoji-box',
  templateUrl: './emoji-box.component.html',
  styleUrls: ['./emoji-box.component.scss']
})

export class EmojiBoxComponent implements OnInit, OnChanges ,OnDestroy {
 // allVip = false;
  user;
  subscriptions: Array<Unsubscribable> = [];
  show = false;
  emojiSets = [];
  width = 470;
  height = 200;
  tabs;
  currentSet;
  currentIndex;
  tabsStyle = {
    // 'border': '1px solid #ddd'
  };

  tabStyle = {
    // 'background-color': '#f8f8f8',
    // 'border-right': '1px solid #ddd',
    'padding-top': '6px',
    'padding-bottom': '6px',
    'padding-left': '8px',
    'padding-right': '8px',
    // 'color': '#222',
  };

  tabActiveStyle = {
    // 'background-color': '#fff',
    // 'color': '#222',
    // 'margin-top': '-1px',
    // 'padding-top': '7px'
  };

  tabHoveredStyle = {
    // 'background-color': '#f8f8f8',
    // 'color': '#222',
  };

  sliderItems = [];

  @Input() isLive = false;
  @Input() hostPage = '';
  isOpenLoading = true;

  // screenType = ScreenSize;
  // screenSize: ScreenSize = ScreenSize.Medium;

  @Input() inActivityBottom = false;

  constructor(
    private _dnEmojiService: DnEmojiService,
    // private _emojiPickerService: EmojiPickerService,
    private _cdr: ChangeDetectorRef,
    private _rechargeBoxService: RechargeBoxService,
    private _permission: PermissionService,
    private _userService:UserService,
   // private _windowService: WindowService,
    // @Inject(AppStore) private store: Store<UsersState>,
    // private _router: Router,
  ) {
    // this._windowService.size$.subscribe((value: any) => {
    //   this.screenSize = value;
    // })
  }
  ngOnChanges(changes:SimpleChanges)
  {
    if(changes['hostPage'])
    {
        this.containerStyle.width = this.hostPage == 'activity'?'100%':this.width+'px';
    }
  }
  readState() {
    // const configState = this.store.getState()['config'];
    // if (configState.config.allVip) {
    //   this.allVip = true;
    // }
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = state.currentUser;
  }
  // private subscript:Array<Unsubscribe> = [];

  ngOnInit() {
    // this.subscript.push(this.store.subscribe(() => this.readState()));
    // this.readState();
    this.user = this._userService.user;
    //this.width = this.hostPage !== 'activity' ? 470 : this.screenSize === this.screenType.Small ? 305 : 440;

    this._userService.userState$.subscribe(user=>{
      this.user = user;
    })
    this.emojiSets.push(this._dnEmojiService.getEmojiItems());
    this.emojiSets.push(this._dnEmojiService.getEmojiDuoFuXiong());
    this.emojiSets.push(this._dnEmojiService.getEmojiHuHu());
    this.emojiSets.push(this._dnEmojiService.getEmojiJiDaBai());
    this.emojiSets.push(this._dnEmojiService.getEmojiMiaoHun());
    this.emojiSets.push(this._dnEmojiService.getEmojiPiLiTu());
    this.emojiSets.push(this._dnEmojiService.getEmojiQiuQiu());
    this.emojiSets.push(this._dnEmojiService.getEmojiTianXingTu());
    this.emojiSets.push(this._dnEmojiService.getEmojiTuBaiBai());

    this.emojiSets.map(set => {
      const rows = Math.floor((this.height - 28) / set.height);
      const columns = Math.floor((this.width - 40) / (set.width));
      const pageSize = rows * columns;
      const pages = Math.ceil(set.items.length / pageSize);
      const horizonSpacing = Math.floor((this.width - (set.width * columns) - (columns + 1) * 2) / 2);

      set.rows = rows;
      set.columns = columns;
      set.pageSize = pageSize;
      set.pages = pages;
      set.horizonSpacing = horizonSpacing;
      return set;
    });
    this.tabs = this.emojiSets.map(item => item.label);
    if (this.isLive) {
      this.tabs = [this.tabs[0]];
    }
    this.currentSet = this.emojiSets[0];
  }

  onSelectTab(event) {
    this.currentIndex = event;
    this.currentSet = this.emojiSets[event];
    this.sliderItems = [];
    for (let i = 0; i < this.currentSet.pages; i++) {
      this.sliderItems.push('');
    }

    this._cdr.detectChanges();
    this.isOpenLoading = false;
  }

  containerStyle = {
    'display': 'block',
    'text-align': 'left',
    'width':  this.width + 'px',
    'height': this.height + 'px',
  };
  sliderStyle() {
    return {
      'padding-left': this.currentSet.horizonSpacing + 'px',
      'padding-right': this.currentSet.horizonSpacing + 'px',
    };
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    // this.subscript.forEach(p=>p());
  }

  showRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
  }

  canNotUseVipEmoj() {
    return this.currentIndex !== 0
      && this.user && !(this.user.daysOfMembership > 0)
      && !this._permission.isValid(SysName.VIPFaceExpression)
     // && !this.allVip;
  }
}
